<template>
  <div id="app" style="width: 100%; margin: 0;padding: 0">
    <header v-if="showHeader" class="head">
      <el-dropdown>
        <i class="el-icon-setting" style="margin-right: 15px"></i>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item ><div @click="logout()">退出</div></el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
      <span style="margin-right: 20px">{{userName}}</span>
    </header>
    <div>
      <el-container style="height: 92vh;overflow-y: auto">
        <el-aside width="200px" class="aside" v-if="showHeader">
          <el-row class="tac">
            <el-col>
              <el-menu :router="true">
                    <el-menu-item index="1" :route="{path:'/template'}">试卷设置</el-menu-item>
                    <el-menu-item index="2" :route="{path:'/exam'}">查看试卷</el-menu-item>
                    <el-menu-item index="3" :route="{path:'/question'}">题目库</el-menu-item>
              </el-menu>
            </el-col>
          </el-row>
        </el-aside>
        <el-main>
          <el-container>
              <router-view></router-view>
          </el-container>
        </el-main>
      </el-container>
    </div>
  </div>
</template>
<script>
import { removeUserId, removeUserName, getUserName, getUserId, getUserType } from './utils/store'
export default {
  name: 'app',
  data () {
    return {
      userId: '',
      userName: '',
      userType: '',
      type: '',
      currentMenuIndex: 0,
      menuItemList: [],
      menuItemListSong: []
    }
  },
  watch: {
    $route () {
      this.userName = getUserName()
    }
  },
  computed: {
    showHeader () {
      if (this.$route.path === '/login' || this.$route.path === '/print') {
        return false
      } else {
        return true
      }
    }
  },
  created () {

  },
  mounted () {
    this.userName = getUserName()
    this.userId = getUserId()
    this.userType = getUserType()
  },
  methods: {
    logout () {
      removeUserId()
      removeUserName()
      location.reload()
    }
  }

}
</script>
<style scoped>
  .head{
    height: 8vh;
    position: relative;
    text-align: right;
    font-size: 12px;
    background-color: #409EFF;
    color: #333;
    line-height: 8vh;
  }
  .el-main {
    margin: 0px;
    padding: 0px;
  }
  .el-container {
    margin: 0px;
    padding: 0px;
  }
</style>
